import { ListItem, ListItemText } from '@cast/design-system';

import { OPTIMIZATION_TYPE_HORIZONTAL_OPTIONS } from 'features/cluster/workload-optimization/_constants';

import type { TypographyProps } from '@cast/design-system';

type OptimizationTypeSelectFooterProps = {
  message?: string;
  disabledItemsTypography?: TypographyProps['variant'];
  messageTypography?: TypographyProps['variant'];
};

export const OptimizationTypeSelectFooter = ({
  message,
  disabledItemsTypography = 'P14R',
  messageTypography = 'P14M',
}: OptimizationTypeSelectFooterProps) => {
  return (
    <>
      <ListItem
        disabled
        sx={{ borderTop: '1px solid', borderTopColor: 'grey.200' }}
        testId="optimization-type-footer-message"
      >
        <ListItemText
          primary={message}
          sx={{ py: 10 }}
          primaryTypographyProps={{
            typography: messageTypography,
            color: 'grey.900',
          }}
        />
      </ListItem>
      {OPTIMIZATION_TYPE_HORIZONTAL_OPTIONS.map((option) => (
        <ListItem
          key={option}
          disabled
          testId={`optimization-type-footer-option-${option.toLowerCase()}`}
        >
          <ListItemText
            primary={option}
            sx={{ py: 10 }}
            primaryTypographyProps={{ typography: disabledItemsTypography }}
          />
        </ListItem>
      ))}
    </>
  );
};
